import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { CommonUtil } from '../../../utils/CommonUtil';
import { NetworkManager } from '../../../Components/NetworkManager';
import { Constants } from '../../Languages/Constants';
import GenericPopup from '../../../Components/GenericPopup';
import ClaimsForm from './ClaimsForm';
import ImageLoaderNew from '../../../Components/ImageLoaderNew';
import ImageModal from '../../../Components/ImageModal';
import ToastManager from '../../../Components/ToastManager';
import Offcanvas from '../../../Components/OffCanvas';
import InspectedImages from './InspectedImages';
import { Events } from '../../Languages/Events';

const InspectionDocument = () => {
  const saasOrgId = CommonUtil.getSaasOrgId();
  const [docDetails, setDocDetails] = useState<any>(null);
  const [docTypes, setDocTypes] = useState<any>(null);
  const [popupInfo, setPopupInfo] = useState<any>(null);
  const [isInterchangeEnabled, setIsInterChangeEnabled] = useState(false);
  const [imgData, setImgData] = useState<any>([]);
  const [imgCompareCount, setImgCompareCount] = useState(0);
  
  let onLoginError = (error:any)=>{
  console.log(error);
  }
  
  let onSwitchCustomer = () => {
      Events.dispatchBreadCrumbEvent();
  }
  
  useEffect(()=>{
    getDocCompare();
    getDocumentDetails();
    getDocTypes();
    localStorage.removeItem("selectedDocTypeId");
    
    document.addEventListener(Events.SWITCH_CUSTOMER_EVENT, onSwitchCustomer);
    return () => {
        document.removeEventListener(Events.SWITCH_CUSTOMER_EVENT, onSwitchCustomer);
    }
  }, [])

  const getDocCompare = () => {
    const orgUrl = `api/dashboard/compare?orgId=${saasOrgId}&isToCompareDifferentDocs=false&docId=${CommonUtil.getInterchangeDocumentId()}`;
    NetworkManager.sendJsonRequest(orgUrl, "", "", "GET", true, onDocCompare, onLoginError);
  };

  const onDocCompare = (dataObj: any) => {
    const restData = JSON.parse(dataObj);
    if (restData && !restData.errorMessage) {
      const images = restData?.inspectionDetails?.map((document: any) => ({
        documentId: document.documentId,
        docTypeName: document.docTypeName || undefined,
        documentCode: document.documentCode,
        vinNumber: document?.vinNumber,
        brand: document?.brand,
        unitNumber: document?.unitNumber,
        licenseNumber: document?.licenseNumber,
        saasOrgId: document.saasOrgId,
        Images: document.processDetails?.flatMap((process: any) =>
          process.taskDetails?.flatMap((task: any) =>
            task?.images?.map((img: any) => ({img: img?.imagePath, comment: img?.comment})) || []
          )
        )
      }));

    const imgCompareCount = images?.reduce((acc: number, doc: any) => {
      return acc + (doc.Images?.length || 0);
    }, 0);

    setImgCompareCount(imgCompareCount);
    setImgData(images);
    } else {
      ToastManager.showToast(restData?.errorMessage || "Unknown error", "Error");
    }
  }

  let getDocTypes = () =>{
    const url = `api/dashboard/doc-doc-types?orgId=${saasOrgId}&docId=${CommonUtil.getInterchangeDocumentId()}`;
    NetworkManager.sendJsonRequest(url,"","","GET",true,(dataObj:any)=>{
    if(dataObj){
      const DocTypes = JSON.parse(dataObj);
      setDocTypes(DocTypes);
    }},onLoginError);
  }

  let getDocumentDetails = () =>{
    const orgUrl = `api/dashboard/document/${CommonUtil.getInterchangeDocumentId()}?orgId=${saasOrgId}`;
    NetworkManager.sendJsonRequest(orgUrl,"","","GET",true,onGetDocumentDetails,onLoginError);
  }
  
  let onGetDocumentDetails = (dataObj:any)=>{
    if(dataObj){
      const restData = JSON.parse(dataObj);
      const documentFieldsList = restData?.documentFields?.map((field: any) => ({
        label: field?.fieldName,
        value: field?.fieldValue,
        imgPath: field?.imagePath,
      }));
      const updatedData = {
        ...restData,
        documentFields: documentFieldsList,
      };
      setIsInterChangeEnabled(updatedData?.isInterchangeEnabled || false);
      setDocDetails(updatedData);
      CommonUtil.setDocStatus(restData?.inspectionDocument?.status)
    }
  }
    
  let onClickAddClaim = () => {
      setPopupInfo({
        type: "AddClaim"
      });
  }

  let closePopup = () => {
      setPopupInfo(null);
  }

  const handleSignaturePopup = (signatureAt: string, item: any) => {
    setPopupInfo({
      type: "Signature",
      at: signatureAt,
      doc: item,
    });
  };

  const handleImageClick = async (img: string[]) => {
    if (img && img.length > 0) {
      const downloadPromises = img.map((imgPath: string) => {
        const qParam = `objectPath=${imgPath}`;
        return new Promise<string>((resolve) => {
          NetworkManager.sendJsonRequest('api/session/downloadUrl', '', qParam, 'GET', true, (data: any) => resolve(data || ""), () => resolve(""));
        });
      });

      const results = await Promise.all(downloadPromises);

      const orderedImageUrls = img.map((path, idx) => ({
        key: path,
        original: results[idx],
      })).filter(item => item.original);
      
      setPopupInfo({
        type: "Img",
        imageSrcs: orderedImageUrls,
      });
    }
  };

   
  const InfoCard = ({ title, items = [] }: any) => (
  <div className="card m-b-0">
    <div className="card-header">{title}</div>
    <ul className="list-group list-group-flush">
      {items?.map(({ label, value, imgPath, isBadge, badgeClass }: any, idx: any) => (
        <li key={idx} className="list-group-item">
          <div className='d-flex justify-content-between align-items-center'>
            <div>
              <p>{label}</p>
              {isBadge ? (
                <span className={`badge ${badgeClass}`}>{value}</span>
              ) : (
                value || "-----"
              )}
            </div>
            <div>
              {title === "Document Details" && imgPath !== null && (
                <img
                  role="button"
                  src="../../images/picture.svg"
                  alt="Task"
                  className="task-picture"
                  onClick={() => handleImageClick([imgPath])}
                />
              )}
            </div>
          </div>
        </li>
      ))}
    </ul>
  </div>
);

const orderTypeData = [
  { label: "Document Code", value: docDetails?.documentCode },
  { label: "Inspection Company", value: docDetails?.orgName },
  { label: "Inspection Type", value: "Interchange" },
  { label: "Document Status", value: docDetails?.documentStatus, isBadge: true, badgeClass: "bg-danger-light" },
  { label: "Creation Date", value: docDetails?.creationDate },
  { label: "Created By", value: docDetails?.createdBy },
];

const equipmentData = [
  { label: "Unit Number #", value: docDetails?.unitNumber },
  { label: "VIN #", value: docDetails?.vinNumber },
  { label: "License Plate Number #", value: docDetails?.licenseNumber },
  { label: "Model Year", value: docDetails?.year },
  { label: "Brand", value: docDetails?.brand },
];

return (
  <div className="p-3 inspection-features">
    <div className='row card-document'>
    <div className="col-xl-3 col-lg-4 col-sm-6 col-sm-12">
      <InfoCard title="Order Type" items={orderTypeData} />
    </div>
    <div className="col-xl-3 col-lg-4 col-sm-6 col-sm-12">
      <InfoCard title="Document Details" items={docDetails?.documentFields} />
    </div>
    <div className="col-xl-3 col-lg-4 col-sm-6 col-sm-12">
      <InfoCard title="Equipment" items={equipmentData} />
      <div className="row">
        <div className="col-sm-12 mt-4 text-center">
          <button
            data-toggle="modal"
            data-target=".bs-example-modal-center-new-claim"
            type="button"
            className="btn btn-dark btn-block w-100"
            data-dismiss="modal"
            onClick={onClickAddClaim}
          >
            {CommonUtil.getMessageText(Constants.ADD_CLAIM, "Add Claim")}
          </button>
        </div>
      </div>
    </div>
    <div className="col-xl-3 col-lg-4 col-sm-6 col-sm-12">
      {docTypes?.map((item: any, i: any) => (<div  className="card action-green mb-4 mt-md-3 mt-lg-0" key={i}>
        <Link 
          to={`/menu/interchangeDashboard/InspectionDocumentDetails`}
          onClick={() => {if(item?.isInterchnageEnabled) localStorage.setItem("selectedDocTypeId", item?.docTypeId)}}
        > 
          <div className="card-header d-flex align-items-center justify-content-between">
            <div className="float-start" style={{maxWidth:"70%"}}>{item?.docTypeName}</div>
            <div className="text-end text-decoration-none">Details <i className="fa-solid fa-arrow-right ms-1"></i></div>
          </div>
        </Link>
        <ul className="list-group list-group-flush">
          <li className="list-group-item">
            <div className='col-12 d-flex justify-content-start align-items-start'>
              <div className='col-6' style={{ borderRight: "1px solid #ddd", paddingRight: "10px" }}>
                <p className='pb-1'>Start Date</p>{item?.startDate ? CommonUtil.convertUtcToLocal(item?.startDate) : "-----"}
              </div>
              <div className='col-6 ps-2'>
                <p className='pb-1'>End Date</p>{item?.endDate ? CommonUtil.convertUtcToLocal(item?.endDate) : "-----"}
              </div>
            </div>
          </li>
          <li className="list-group-item">
            <div className='col-12 d-flex justify-content-start align-items-start'>
              <div className='col-6' style={{ borderRight: "1px solid #ddd", paddingRight: "10px" }}>
                <p style={{paddingBottom: "1px"}}>Duration</p>
                {item?.duration ? <div className='mt-2'>{item?.duration}</div> : "-----"}
              </div>
              <div className='col-6 ps-2'>
                <p className='pb-1'>Signature</p>
                {Object.keys(item?.signatureDetails)?.length > 0 ? <div className="d-flex m-0">
                  {item?.signatureDetails?.Start?.length > 0 && (
                    <button type="button" className="btn btn-outline-dark me-1"
                      onClick={() => handleSignaturePopup("Start", item)}
                    >Start</button>
                  )}
                  {item?.signatureDetails?.End?.length > 0 && (
                    <button type="button" className="btn btn-outline-dark mx-1"
                      onClick={() => handleSignaturePopup("End", item)}>End</button>
                  )}
                </div> : "-----"}
              </div>
            </div>
          </li>
          <li className="list-group-item">
            <p>Download & Share</p>
            <div className="d-flex align-items-center mt-1 ms-0">
              {/* <img src="../../images/download-lite.svg" alt="download" style={{width: "13px", marginTop: "3px"}} /> */}
              <span className="mx-1" role="button" 
                onClick={()=>setPopupInfo({type: "imgDrawer", imageSrcs: [imgData?.[i]], imgCount: imgData?.[i]?.Images?.length})} 
                style={{textDecoration: "none", color:"#4C80CA"}}>
                <u><b>Download / Share</b></u>
              </span>{imgData?.[i]?.Images?.length || 0} Pictures
            </div>
          </li>
        </ul>
      </div>))}
      {isInterchangeEnabled && <div className="card action-red mb-4">
        <Link to={`/menu/interchangeDashboard/InspectionDocumentCompare`}> 
          <div className="card-header d-flex align-items-center justify-content-between">
            <div className="float-start">Compare</div>
            <div className="text-end text-decoration-none">Details <i className="fa-solid fa-arrow-right ms-1"></i></div>
          </div>
        </Link>
        <ul className="list-group list-group-flush">
          <li className="list-group-item">
            <div className='col-12 d-flex justify-content-start align-items-start'>
              <div className='col-6' style={{ borderRight: "1px solid #ddd", paddingRight: "10px" }}>
              <p className='pb-1'>{docTypes?.[0]?.docTypeName} Date</p>{docTypes?.[0]?.endDate ? CommonUtil.convertUtcToLocal(docTypes?.[0]?.endDate) : "-----"}
              </div>
              <div className='col-6 ps-2'>
                <p className='pb-1'>{docTypes?.[docTypes?.length - 1]?.docTypeName} Date</p>{docTypes?.[docTypes?.length - 1]?.endDate ? CommonUtil.convertUtcToLocal(docTypes?.[docTypes?.length - 1]?.endDate) : "-----"}
              </div>
            </div>
          </li>
          <li className="list-group-item">
            <p className='pb-1'>Trailer Return Duration</p>{docTypes?.[0]?.trailerReturnDuration ? docTypes?.[0]?.trailerReturnDuration : "-----"}
          </li>
          <li className="list-group-item">
            <p>Download & Share</p>
            <div className="d-flex align-items-center mt-1 ms-0">
              <span className="mx-1" role="button" 
                onClick={() => setPopupInfo({type: "imgDrawer", imageSrcs: imgData, imgCount: imgCompareCount})} 
                style={{textDecoration: "none", color:"#4C80CA"}}>
                <u><b>Download / Share</b></u>
              </span>{imgCompareCount || 0} Pictures
            </div>
          </li>
        </ul>
      </div>}
    </div>
    {popupInfo?.type === "AddClaim" && (
      <GenericPopup header="Claim" mode="add" onClose={closePopup} size="lg">
        <ClaimsForm onClose={closePopup} mode="add" />
      </GenericPopup>
    )}
    {popupInfo?.type === "Signature" && (
      <GenericPopup
        header={`Signature ${popupInfo?.at}`}
        mode={`${popupInfo?.type}`}
        onClose={closePopup}
        size="lg"
      >
        <div className="" style={{ display: 'flex', flexWrap: 'wrap' }}>
          {popupInfo?.doc?.signatureDetails?.[popupInfo?.at]?.map((item: any, i: number) => (
            <div 
              className="card" 
              key={`${item?.signatureBy}-${i}`}
              style={{ flex: '1 0 200px', display: 'flex', flexDirection: 'column', margin: '0.3rem' }}
            >
              <div style={{ flex: '1', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <ImageLoaderNew
                  path={item?.signFilePath}
                  index={0}
                  onLoad={() => {}}
                  className="img-fluid mb-2"
                  style={{width: "100%", height: "auto", maxHeight: "200px", objectFit: "contain"}}
                />
              </div>
              <div className="card-footer">
                <span>{item?.signatureBy} - {item?.signatureByName}</span>
              </div>
            </div>
          ))}
        </div>
      </GenericPopup>
    )}
  </div>
    {popupInfo?.type === "Img" && (
      <ImageModal
        isOpen={popupInfo?.type === "Img"}
        imageSrcs={popupInfo?.imageSrcs}
        caption={""}
        onClose={() => {
          setPopupInfo(null);
        }}
      />
    )}
    <Offcanvas 
      show={popupInfo?.type === "imgDrawer"}
      onHide={() => {setPopupInfo(null);}}
      title="Download / Share Pictures"
      size="70%"
    >
      <InspectedImages data={popupInfo?.imageSrcs} imageCount={popupInfo?.imgCount} show={popupInfo?.type === "imgDrawer"} />
    </Offcanvas>
  </div>
);
};

export default InspectionDocument;
